import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBUGL5QRF0PaGywG0srKNt-_UHkXzu_Xds",
  authDomain: "krishna-bc116.firebaseapp.com",
  projectId: "krishna-bc116",
  storageBucket: "krishna-bc116.firebasestorage.app",
  messagingSenderId: "301212163735",
  appId: "1:301212163735:web:be3bb9f270956a4dff53d2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };



